import api from "./axiosInstance";

export const login = async (pin: string) => {
  const res = await api.post("/login", { pin });
  localStorage.setItem("token", res.data.token);
  return res.data.token;
};

export const getToken = () => localStorage.getItem("token");
export const logout = () => localStorage.removeItem("token");